import { Program } from "../../../types/gqlTypes/graphql"
import { convertSecondsToHours } from "../helpers"
import { SUBJECTS_WITH_HALF_HOUR_STEP } from "./constants"

export const getDefaultErrorMessage = (reason: string) =>
  `An error occurred${
    reason ? ` while trying to ${reason}` : ""
  }. Please try again. If the error persists, contact support for help.`

export const getPlanHoursData = (
  program: Program,
  subject: string,
  seconds?: number
): { minHours: number; step: number; currentHours: number } => {
  const currentSeconds = seconds || 0

  if (SUBJECTS_WITH_HALF_HOUR_STEP[program]?.[subject]) {
    return {
      minHours: 0.5,
      step: 0.5,
      currentHours: convertSecondsToHours(currentSeconds, 2)
    }
  }

  return {
    minHours: 1,
    step: 1,
    currentHours: convertSecondsToHours(currentSeconds)
  }
}

export const getRoundedMaxAvailableHours = (
  program: Program,
  subject: string,
  seconds?: number
) => {
  const maxAvailableSeconds = seconds || 0

  if (SUBJECTS_WITH_HALF_HOUR_STEP[program]?.[subject]) {
    return convertSecondsToHours(maxAvailableSeconds, 2)
  }

  return Math.ceil(maxAvailableSeconds / 3600)
}
